import { useState } from 'react';
import { LayoutModule } from '../../../layout/modules';
import { Submotive1Filters } from './filters';
import { Submotive1List } from './list';
import { SUBMOTIVE1, SUBMOTIVE1_NEW } from '../../../../routes/paths';
import ActionButtonGroup from '../../../components/general/buttons/actionButtonGroup';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../redux/store';
import { isOnlyViewProfile } from '../../../../shared/types/profiles';
import { Param } from '../../../../shared/types/param';

export const Submotive1 = () => {
    const [filters, setFilters] = useState<Param>();

    const { logUser } = useSelector((state: RootState) => state.general);
    const { type } = logUser || {};
    return (
        <>
            <LayoutModule
                title="Búsqueda de submotivo 1"
                showTitle
                additionalButtons={
                    <ActionButtonGroup
                        buttonCreate={{
                            show: !isOnlyViewProfile(type),
                            route: SUBMOTIVE1_NEW,
                        }}
                        buttonSearch={{
                            show: true,
                            route: SUBMOTIVE1,
                        }}
                    />
                }
            >
                <Submotive1Filters
                    onFilter={(filters) => setFilters(filters)}
                />
            </LayoutModule>
            <Submotive1List filters={filters} />
        </>
    );
};
